import { IconButton } from "@/elements"
import { EllipsisHorizontalIcon } from "@heroicons/react/24/outline"

const TableRowCellLoader = ({ width }: { width: number }) => {
  return (
    <td className={`whitespace-break-spaces px-4 text-left`}>
      <div
        className="flex h-[12px] animate-pulse items-center rounded-sm bg-bg-3"
        style={{
          width: width ? `${width}px` : "auto",
        }}></div>
    </td>
  )
}

interface Props {
  index: number
}

const LoaderRow: React.FC<Props> = ({ index }) => {
  return (
    <tr key={index} className={`h-[54px] border-b border-bg-3 hover:bg-primary-1 hover:bg-opacity-20`}>
      <TableRowCellLoader width={300} />
      <TableRowCellLoader width={100} />
      <TableRowCellLoader width={100} />
      <TableRowCellLoader width={30} />
      <td className="flex h-[53px] items-center justify-center whitespace-nowrap px-6">
        <IconButton variant="white" Icon={EllipsisHorizontalIcon} />
      </td>
    </tr>
  )
}

export default LoaderRow
